import { useMutation } from '@tanstack/react-query'

import { AxiosError } from 'axios'
import { ErrorHandling } from '../../@types/ErrorHandling'
import {
  GetAdditionalEntityDetailsForSummaryDocumentRequest,
  GetAdditionalEntityDetailsForSummaryDocumentResponse,
} from '../../@types/GetAdditionalEntityDetailsForSummaryDocument'
import { ENV } from '../../Environment'
import { api } from '../../Services/API'
import { useEntityDetailsForSummaryDocumentStore } from '../../Stores/useEntityDetailsForSummaryDocumentStore'
import { API_ROUTES } from '../../constants/apiRoutes'
import { useErrorRequest } from '../useErrorRequest'

const headers = {
  'aip-company': ENV().AdditionalEntityDetailsForSummaryDocument.Company,
  'aip-channel': ENV().AdditionalEntityDetailsForSummaryDocument.Channel,
}

const request = async (
  payload: GetAdditionalEntityDetailsForSummaryDocumentRequest,
) => {
  const response =
    await api.post<GetAdditionalEntityDetailsForSummaryDocumentResponse>(
      API_ROUTES.getAdditionalEntityDetailsForSummaryDocument,
      payload,
      { headers },
    )

  return response.data
}

export const useGetAdditionalEntityDetailsForSummaryDocument = () => {
  const { updateEntityDetailsForSummaryDocumentSelected } =
    useEntityDetailsForSummaryDocumentStore()
  const { handleErrorRequest } = useErrorRequest()

  return useMutation({
    mutationFn: (
      payload: GetAdditionalEntityDetailsForSummaryDocumentRequest,
    ) => request(payload),
    onSuccess(data) {
      updateEntityDetailsForSummaryDocumentSelected(data)
    },
    onError(error: AxiosError<ErrorHandling[]>) {
      handleErrorRequest({ error })
    },
  })
}
